"use client";

import Signin from "@/components/Auth/Signin";
import { GoogleAuth, DividerWithText } from "@/components/Auth/GoogleAuth";
import Image from "next/image";
import Link from "next/link";

export default function SignIn() {
  return (
    <div className="rounded-[10px] bg-white shadow-1 dark:bg-gray-dark dark:shadow-card">
      <div className="flex flex-wrap items-center">
        <div className="w-full xl:w-1/2">
          <div className="w-full p-4 sm:p-12.5 xl:p-15">
            <h1 className="mb-4 text-2xl font-bold text-dark dark:text-white sm:text-heading-4">
              Welcome Back
            </h1>
            <p className="mb-6 font-medium text-dark-4 dark:text-dark-6">
              Sign in to continue to your account
            </p>
            <GoogleAuth action="login" />
            <DividerWithText text="Or sign in with email" />
            <Signin />
          </div>
        </div>

        <div className="hidden w-full p-7.5 xl:block xl:w-1/2">
          <div className="custom-gradient-1 overflow-hidden rounded-2xl px-12.5 pt-12.5 dark:!bg-dark-2 dark:bg-none">
            <Link className="mb-10 inline-block" href="/">
              <Image
                className="hidden dark:block"
                src={"/images/logo/subtitle-me-light-logo.png"}
                alt="Subtitle Me"
                width={300}
                height={55}
                priority
              />
              <Image
                className="dark:hidden"
                src={"/images/logo/subtitle-me-dark-logo.png"}
                alt="Logo"
                width={300}
                height={55}
                priority
              />
            </Link>
            <p className="mb-3 text-xl font-medium text-dark dark:text-white">
              Sign in to your account
            </p>
            <h2 className="mb-4 text-2xl font-bold text-dark dark:text-white sm:text-heading-4">
              Welcome Back!
            </h2>
            <p className="w-full max-w-[375px] font-medium text-dark-4 dark:text-dark-6">
              Please sign in to your account using your registered email
              address.
            </p>
            <div className="mt-31">
              <Image
                src={"/images/grids/grid-02.svg"}
                alt="Decoration"
                width={405}
                height={325}
                className="mx-auto dark:opacity-30"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
